// Mini-cart enhancements
//   1. Rotates the "Frequently added to cart" upsell list — Fisher–Yates shuffle
//      on each drawer open. CSS caps visible tiles at 3, so whichever tiles land
//      at index 4+ are hidden this round.
//   2. Intercepts upsell ADD button clicks, POSTs to /cart/add.js, then
//      dispatches `cart:refresh` so the theme's Header class re-renders the drawer.
(function () {
  'use strict';

  var UPSELL_LIST_SEL = '[data-mini-cart-upsells]';
  var UPSELL_ADD_SEL = '[data-mini-cart-upsell-add]';

  function shuffleUpsells(list) {
    if (!list || list.dataset.rotated === '1') return;
    var tiles = Array.prototype.slice.call(list.children);
    if (tiles.length < 2) return;
    for (var i = tiles.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = tiles[i]; tiles[i] = tiles[j]; tiles[j] = tmp;
    }
    tiles.forEach(function (t) { list.appendChild(t); });
    list.dataset.rotated = '1';
  }

  function rotateAllUpsells(root) {
    (root || document).querySelectorAll(UPSELL_LIST_SEL).forEach(shuffleUpsells);
  }

  // Rotate when drawer opens or re-renders
  function handleDrawerMaybeOpen() {
    rotateAllUpsells();
  }

  // Listen for the theme's cart:rerendered event — fires after _rerender()
  document.addEventListener('cart:rerendered', function () {
    // Reset rotated flag on any new upsell lists and reshuffle
    document.querySelectorAll(UPSELL_LIST_SEL).forEach(function (list) {
      delete list.dataset.rotated;
    });
    rotateAllUpsells();
  }, true);

  // Also rotate on cart open via toggle-mini-cart click
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-action="toggle-mini-cart"]')) {
      // Reset flag so re-opening reshuffles
      document.querySelectorAll(UPSELL_LIST_SEL).forEach(function (list) {
        delete list.dataset.rotated;
      });
      // Tiny delay so the drawer's open animation has the tiles in position
      setTimeout(rotateAllUpsells, 30);
    }
  }, true);

  // Swap the mini-cart drawer body using HTML returned in the add.js
  // `sections` response — saves a second network roundtrip (the theme's
  // default cart:refresh fetches the section separately).
  function swapMiniCartFromHtml(html) {
    var miniCart = document.querySelector('#mini-cart');
    if (!miniCart || !html) return false;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    // The sections response wraps the section in its own root; the actual
    // drawer markup is inside the .mini-cart element.
    var newMiniCart = temp.querySelector('.mini-cart');
    if (!newMiniCart) return false;

    // Preserve scroll position of the items list across the swap
    var oldList = miniCart.querySelector('.mini-cart__line-item-list');
    var scrollTop = oldList ? oldList.scrollTop : 0;

    miniCart.innerHTML = newMiniCart.innerHTML;

    var newList = miniCart.querySelector('.mini-cart__line-item-list');
    if (newList) newList.scrollTop = scrollTop;

    // Update header cart count from the new markup if present
    var countAttr = newMiniCart.getAttribute('data-item-count');
    if (countAttr != null) {
      var headerCount = document.querySelector('.header__cart-count');
      if (headerCount) headerCount.textContent = countAttr;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
    return true;
  }

  // Intercept upsell ADD button clicks
  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest ? e.target.closest(UPSELL_ADD_SEL) : null;
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();

    if (button.disabled) return;

    // OPTIMISTIC UI — flip the button to "Added ✓" the instant you click,
    // before the network even responds. Feels instant even on slow add.
    var originalLabel = button.textContent;
    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading', 'is-added');
    button.textContent = '✓';

    var variantId = button.getAttribute('data-variant-id');
    var quantity = parseInt(button.getAttribute('data-quantity') || '1', 10);

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', String(quantity));
    // Ask Shopify to render the mini-cart section in the same response so
    // we don't need a second fetch to refresh the drawer.
    body.append('sections', 'mini-cart');
    body.append('sections_url', window.location.pathname);

    var addUrl = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (r.ok) {
          // Mark this add as "user-initiated" so the GWP listener can use
          // the section HTML for its check instead of doing a /cart.js roundtrip.
          var sectionHtml = r.data && r.data.sections && r.data.sections['mini-cart'];
          if (sectionHtml) {
            // Skip the slow theme cart:refresh path entirely.
            swapMiniCartFromHtml(sectionHtml);
          } else {
            // Fall back to theme's path if sections weren't returned for any reason.
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true, detail: { scrollToTop: false }
            }));
          }
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: r.data, quantity: quantity }
          }));
        } else {
          // Roll back optimistic UI on failure
          button.removeAttribute('disabled');
          button.classList.remove('is-loading', 'is-added');
          button.textContent = originalLabel;
          button.classList.add('is-error');
          setTimeout(function () { button.classList.remove('is-error'); }, 1500);
        }
      })
      .catch(function () {
        // Roll back optimistic UI on network error
        button.removeAttribute('disabled');
        button.classList.remove('is-loading', 'is-added');
        button.textContent = originalLabel;
      });
  }, true);

  // ---------------------------------------------------------------------------
  // Gift-with-purchase: auto-add the free White T10 Globes when cart >= $300,
  // auto-remove when cart drops back below. Debounced + guarded so we never
  // fall into an add→rerender→add loop.
  // ---------------------------------------------------------------------------
  var GWP_HANDLE = 't10-led-bulb-free';
  var GWP_THRESHOLD_CENTS = 30000; // $300 AUD
  var gwpVariantIdPromise = null;
  var gwpInFlight = false;

  function getGwpVariantId() {
    if (gwpVariantIdPromise) return gwpVariantIdPromise;
    gwpVariantIdPromise = fetch('/products/' + GWP_HANDLE + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return null;
        var available = product.variants.filter(function (v) { return v.available; })[0];
        return (available || product.variants[0]).id;
      })
      .catch(function () { return null; });
    return gwpVariantIdPromise;
  }

  function findGwpLine(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === GWP_HANDLE) return cart.items[i];
    }
    return null;
  }

  function reconcileGwp() {
    if (gwpInFlight) return;
    gwpInFlight = true;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) { gwpInFlight = false; return; }
        var gwpLine = findGwpLine(cart);

        // Subtotal excluding the free item itself (so removing it doesn't
        // trip us just below the threshold by its own listed price).
        var subtotal = cart.total_price;
        if (gwpLine) subtotal -= gwpLine.final_line_price;

        if (subtotal >= GWP_THRESHOLD_CENTS && !gwpLine) {
          // Add the gift
          return getGwpVariantId().then(function (variantId) {
            if (!variantId) { gwpInFlight = false; return; }
            var body = new FormData();
            body.append('id', variantId);
            body.append('quantity', '1');
            body.append('properties[_gift]', 'true');
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
              body: body
            }).then(function () {
              gwpInFlight = false;
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true, detail: { scrollToTop: false, __gwp: true }
              }));
            });
          });
        }

        if (subtotal < GWP_THRESHOLD_CENTS && gwpLine) {
          // Remove the gift
          var body = new FormData();
          body.append('id', String(gwpLine.key));
          body.append('quantity', '0');
          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: body
          }).then(function () {
            gwpInFlight = false;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true, detail: { scrollToTop: false, __gwp: true }
            }));
          });
        }

        gwpInFlight = false;
      })
      .catch(function () { gwpInFlight = false; });
  }

  // Hide qty controls on the gift line so customers can't bump it
  function lockGwpLine() {
    document.querySelectorAll('[data-mini-cart-line]').forEach(function (line) {
      var title = line.querySelector('.mini-cart__item-title, [data-mini-cart-line-title]');
      var href = (title && title.getAttribute && title.getAttribute('href')) || '';
      var text = (title && title.textContent) || '';
      if (href.indexOf(GWP_HANDLE) !== -1 || /free/i.test(text) && /t10/i.test(text)) {
        line.classList.add('mini-cart__item--gift');
      }
    });
  }

  document.addEventListener('cart:rerendered', function () {
    lockGwpLine();
    // Don't loop forever — reconcile only if this wasn't a GWP-driven refresh
    setTimeout(reconcileGwp, 50);
  }, true);

  // Run once on initial page load (drawer may render with items pre-loaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rotateAllUpsells();
      lockGwpLine();
      reconcileGwp();
    });
  } else {
    rotateAllUpsells();
    lockGwpLine();
    reconcileGwp();
  }
})();
